import * as Long from "long";
import { ofType } from "redux-observable";
import { from, of } from "rxjs";
import { filter, switchMap } from "rxjs/operators";
import { selectBuildingInfoById, selectBuildingRemovedProduction, selectSelectedBuildingInfo, } from "../../../../selectors/selectExistingBuildingInfo";
import { selectNonCollectibleProduct } from "../../../../selectors/selectRecipeInfo";
import { selectIsTutorialBuilding } from "../../../../selectors/selectTutorial";
import { throttleGroupPerTime } from "../../../../utils/rxjs/custom-operators/throttleGroupPerTime";
import { utilBugSnag } from "../../../../utils/utilBugSnag";
import { utilBuildings } from "../../../../utils/utilBuildings";
import { utilTime } from "../../../../utils/utilTime";
import { actionProductionInfoRemoveProduction, actionProductionPreCollect, actionProductionReAdd, } from "../../../info/production/actionProductionInfo";
import { actionBuildingsAddPellets, actionBuildingsDeselect, actionBuildingsSelect, TypeActionBuildings, } from "../actionBuildings";
var serverFailureTimeout = 1.5;
export var epicBuildingsPreSelect = function (action$, state$) {
    return action$.pipe(ofType(TypeActionBuildings.PreSelect), throttleGroupPerTime(function (a) { return a.building.proto.id; }, 2, // allow two items per window, so user is able to collect and open menu with two rapid clicks
    1000), filter(function (action) {
        return selectIsTutorialBuilding(state$.value, action.building) &&
            action.building != undefined;
    }), switchMap(function (action) {
        var state = state$.value;
        var buildingFromAction = action.building;
        // refresh building because it might be outdated when coming from the pixi layer
        var building = selectBuildingInfoById(state, buildingFromAction.proto.id);
        utilBugSnag.addBuildingBugsnagBreadcrumb(building);
        var selectedBuilding = selectSelectedBuildingInfo(state);
        if (selectedBuilding &&
            utilBuildings.hasFinishedProduction(buildingFromAction) &&
            action.building.proto !== selectedBuilding.proto) {
            return of(actionBuildingsDeselect());
        }
        var removedProduction = selectBuildingRemovedProduction(state, building.proto.id);
        var removedProductionRequestFailed = removedProduction &&
            utilTime.secondsElapsedSince(removedProduction.timestamp) > serverFailureTimeout;
        if (removedProductionRequestFailed) {
            return from([actionBuildingsDeselect(), actionProductionReAdd(building.proto.id)]);
        }
        if (!utilBuildings.hasFinishedProduction(building)) {
            return of(actionBuildingsSelect(building, action.buildingCenterCoords));
        }
        var _a = building.production.recipe, product = _a.product, xp = _a.xp;
        var nonCollectibleProduct = selectNonCollectibleProduct(state, product, building);
        if (nonCollectibleProduct != undefined) {
            return of(actionBuildingsSelect(building, action.buildingCenterCoords));
        }
        var productionList = product == undefined
            ? []
            : product.map(function (resource) {
                return {
                    amount: Long.fromNumber(resource.amount),
                    typeId: resource.resourceId,
                };
            });
        var productionXp = xp.amount;
        var preCollectProductResponse = {
            adventurerXp: Long.ZERO,
            buildingId: building.proto.id,
            farmId: state.playerBase.base.baseId,
            product: productionList,
            xp: Long.fromNumber(productionXp || 0),
        };
        return from([
            actionProductionInfoRemoveProduction(building.proto.id),
            actionProductionPreCollect(building, preCollectProductResponse),
            actionBuildingsAddPellets(building),
        ]);
    }));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/player-base/buildings/epics/epicBuildingsPreSelect.ts
// module id = 2057
// module chunks = 3